import React from "react"
import { Container } from "semantic-ui-react"

import Carousel from "../components/Index/Carousel/Carousel"
import GalleryPhotos from "../components/Index/GalleryPhotos"
import ArraysCategory from "../components/Index/ArraysCategory/ArraysCategory"
import CarouselNews from "../components/Index/CarouselNews/CarouselNews"

const Home = () => (
  <div className='container-Sections'>
    <Carousel />
    <ArraysCategory />
    <Container className='pt-6 pb-6 w-75'>
      <GalleryPhotos />
    </Container>
    <Container className='pt-5 pb-5 w-75'>
      <CarouselNews />
    </Container>
  </div>
)

export default Home
